import { render, staticRenderFns } from "./TDMember.vue?vue&type=template&id=0976cdb4&scoped=true&"
import script from "./TDMember.vue?vue&type=script&lang=js&"
export * from "./TDMember.vue?vue&type=script&lang=js&"
import style0 from "./TDMember.vue?vue&type=style&index=0&id=0976cdb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0976cdb4",
  null
  
)

export default component.exports